export default "__VITE_ASSET__CWYlkPHL__"